/*
Version 0.145

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	- [CHANGE] New version and setup of methods and so on
2020
	28-22-2020
	- [CHANGE] Some things
2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_360 = {};

(function(){

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	/*
	Load the tour
	*/
	this.onready = function() {

		/*
		Show the tour loader
		*/
		$('#tour').show();
		
		var _coordinates_array;
		var _scene_step;
		
		//var search1 				= new URLSearchParams(window.location.search);

		/*
		Catch URL
		*/
		// var _zoom_on_mousewheel 	= search1.get("mousewheel");
		// var _autoplay 				= search1.get("autoplay");
		// var _button_color 			= search1.get("button_color");
		// var _button_position 		= search1.get("button_position");
			
		/*
		Load KRPano wrapper
		*/
		if(_device == 'desktop') {
			
			embedpano({
				swf 				: globalUrl + "/vtour/tour.swf", 
				xml 				: globalUrl + "/vtour/tour.xml?v=" + Math.random(),
				target 				: "tour",
				html5 				: "always",
				mobilescale 		: 1.0,
				passQueryParameters : true,
				focus				: false,
				mwheel 				: true,
				bgcolor 			: "#ffffff",
				onready				: specific_360.toggleLoading(0)
			});
		
		} else {
			
			embedpano({
				swf 				:globalUrl + "/vtour/tour.swf", 
				xml 				:globalUrl + "/vtour/tour-mobile.xml?v=" + Math.random(),
				target 				:"tour",
				html5 				:"always",
				mobilescale 		:1.0,
				passQueryParameters :true,
				focus				:false,
				mwheel 				:true,
				bgcolor 			:"#ffffff"
			});
			
		}
		
		/*
		Listeners: Bind
		*/
		$(document).on('click','html body',function() {

			/*
			Autoplay: Disable 
			*/
			krpano.call('set(autorotate.enabled,false)');

		  	/*
		  	Autoplay: Active again?
		  	*/
		  	specific_360.setAutoplay();
		  	
		});
		
		/*
		Define KRPano
		*/
		krpano = document.getElementById('krpanoSWFObject');

		/*
		Load URL
		*/
		specific_360.updateUrl('');
		
		/*
		Coordinates: Catch in console
		*/
		//specific_360.trackCoordinates();
		
		/*
		Check Gyro / VR on Desktop / Mobile
		*/
		switch(_device) {
		
			case 'desktop':
				//$('.js-button-fullscreen').show();
				//$('.js-button-360').hide();
				//$('.js-button-vr').hide();	
			break;
			
			case 'tablet':
				//$('.js-button-fullscreen').hide();
				//$('.js-button-360').show();
				//$('.js-button-vr').hide();	
			break;
			
			case 'smartphone':
				//$('.js-button-fullscreen').show();
				//$('.js-button-360').show();
				//$('.js-button-vr').show();	
			break;
			
		}
		
	};
		
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
		
		/*
		Loading: Toggle
		*/
		this.toggleLoading = function(
			i
		) {
			
			var _show = 1;
			if(i == 0) {
				_show = 0;
			}

			if(_show == 1) {
				$('.js-loader').show();
			} else {
				$('.js-loader').hide();
			}
		};

		/*
		Info: Toggle
		*/
		// this.toggleInfo = function() {

		// 	if($('.js-info-status').val() == 0) {
			
		// 		$('.js-info').stop().animate({
		// 			'right':0
		// 		},500,'easein');

		// 		$('.js-info-status').val(1);

		// 		$('.js-open').hide();
		// 		$('.js-close').show();

		// 	} else {

		// 		$('.js-info').stop().animate({
		// 			'right':-600
		// 		},500,'easein');

		// 		$('.js-info-status').val(0);

		// 		$('.js-open').show();
		// 		$('.js-close').hide();

		// 	}

		// };

		/*
		Update pano URL and go routing
		*/
		this.updateUrl = function(
			new_url
		) {

			/*
			Loader
			*/
			$('.js-loading').show();

			/*
			Set: Autoplay
			*/
			_autoplay = false;

			/*
			Set: Begin scene
			*/
			// if(url[1] === '') {
				
			// 	window.location = globalUrl + '/centrale-hal/-214|0|0';
				
			// } else {
				
			if(
				typeof new_url !== 'undefined' && 
				new_url !== ''
			) {

				var _new_url 		= $('.js-settings-category').val() + '/' + new_url;

				var _urlParams 		= new URLSearchParams(window.location.search);

				window.history.pushState(
					'obj',
					'',
					globalUrl + '/' + _new_url + '?' + _urlParams
				);
			}

			// }
			
			/*
			Get new URL
			*/
			url = getUrl();

			/*
			Set: is Page
			*/
			$('.js-settings-ispage').val('false');

			/*
			Set: Scene
			*/
			switch(url[1]) {

				default:

					_call_scene = 'ENTREE-MET-KIDS';

					/*
					Position: Set
					*/
					if(url[2] == '') {
						_coordinates_array 		= '-214|0|0';
					} else {
						_coordinates_array 		= url[2];
					}
					_coordinates_array 			= _coordinates_array.split('|');

					/*
					Set: Autoplay
					*/
					_autoplay = false;

					/*
					Side menu: toggle
					*/
					specific_digidag_sidemenu.toggleCategory('onderbouw');
					specific_digidag_sidemenu.subItemActive('centrale-hal');

				break;

				/*
				SCENES EN PAGES **********************************************************
				SCENES EN PAGES **********************************************************
				SCENES EN PAGES **********************************************************
				SCENES EN PAGES **********************************************************
				SCENES EN PAGES **********************************************************
				SCENES EN PAGES **********************************************************
				SCENES EN PAGES **********************************************************
				SCENES EN PAGES **********************************************************
				*/
				case 'ouder':
				case 'kind':
				case 'leerkracht':

					switch(url[2]) {

						default:

						case 'kort-en-bondig':
						case 'ervaringen':
						case 'team':
						case 'delen':
						case 'contact':

						case 'centrale-hal':
					
							_call_scene = 'ENTREE-MET-KIDS';

							/*
							Position: Set
							*/
							if(url[4] == '') {
								_coordinates_array 		= '-214|0|0';
							} else {
								_coordinates_array 		= url[4];
							}
							_coordinates_array 			= _coordinates_array.split('|');

							/*
							Set: Autoplay
							*/
							_autoplay = true;

							/*
							Side menu: toggle
							*/
							specific_digidag_sidemenu.toggleCategory('onderbouw');
							specific_digidag_sidemenu.subItemActive('centrale-hal');

							/*
							Audioplayer
							*/
							specific_digidag_audioplayer.switchAudio(
								url[1] + '-centrale-hal.mp3',
								'centrale-hal',
								1
							);

						break;

						case 'bovenbouw':
					
							_call_scene = 'GANG-BOVENBOUW';

							/*
							Position: Set
							*/
							if(url[4] == '') {
								_coordinates_array 		= '-295|0|13';
							} else {
								_coordinates_array 		= url[4];
							}
							_coordinates_array 			= _coordinates_array.split('|');

							/*
							Set: Autoplay
							*/
							_autoplay = true;

							/*
							Side menu: toggle
							*/
							specific_digidag_sidemenu.toggleCategory('bovenbouw');
							specific_digidag_sidemenu.subItemActive('bovenbouw');

							/*
							Audioplayer
							*/
							specific_digidag_audioplayer.switchAudio(
								url[1] + '-bovenbouw.mp3',
								'bovenbouw',
								2
							);

						break;

						case 'kleuterklas':
					
							_call_scene = 'KLAS1';

							/*
							Position: Set
							*/
							if(url[4] == '') {
								_coordinates_array 		= '-444|0|25';
							} else {
								_coordinates_array 		= url[4];
							}
							_coordinates_array 			= _coordinates_array.split('|');

							/*
							Set: Autoplay
							*/
							_autoplay = true;

							/*
							Side menu: toggle
							*/
							specific_digidag_sidemenu.toggleCategory('onderbouw');
							specific_digidag_sidemenu.subItemActive('kleuterklas');

							/*
							Audioplayer
							*/
							specific_digidag_audioplayer.switchAudio(
								url[1] + '-kleuterklas.mp3',
								'kleuterklas',
								3
							);

						break;

						case 'gang':
					
							_call_scene = 'GANG-ONDERBOUW';

							/*
							Position: Set
							*/
							if(url[4] == '') {
								_coordinates_array 		= '-363|0|12';
							} else {
								_coordinates_array 		= url[4];
							}
							_coordinates_array 			= _coordinates_array.split('|');

							/*
							Set: Autoplay
							*/
							_autoplay = true;

							/*
							Side menu: toggle
							*/
							specific_digidag_sidemenu.toggleCategory('onderbouw');
							specific_digidag_sidemenu.subItemActive('gang');

							/*
							Audioplayer 
							*/
							specific_digidag_audioplayer.switchAudio(
								url[1] + '-gang.mp3',
								'gang',
								4
							);

						break;

						case 'groep-3':
					
							_call_scene = 'KLAS2';

							/*
							Position: Set
							*/
							if(url[4] == '') {
								_coordinates_array 		= '-654|0|4';
							} else {
								_coordinates_array 		= url[4];
							}
							_coordinates_array 			= _coordinates_array.split('|');

							/*
							Set: Autoplay
							*/
							_autoplay = true;

							/*
							Side menu: toggle
							*/
							specific_digidag_sidemenu.toggleCategory('onderbouw');
							specific_digidag_sidemenu.subItemActive('groep-3');

							/*
							Audioplayer
							*/
							specific_digidag_audioplayer.switchAudio(
								url[1] + '-groep3.mp3',
								'groep-3',
								5
							);

						break;

						case 'schoolplein':
					
							_call_scene = 'PLEIN';

							/*
							Position: Set
							*/
							if(url[4] == '') {
								_coordinates_array 		= '-363|0|12';
							} else {
								_coordinates_array 		= url[4];
							}
							_coordinates_array 			= _coordinates_array.split('|');

							/*
							Set: Autoplay
							*/
							_autoplay = true;

							/*
							Side menu: toggle
							*/
							specific_digidag_sidemenu.toggleCategory('buiten');
							specific_digidag_sidemenu.subItemActive('schoolplein');

							/*
							Audioplayer
							*/
							specific_digidag_audioplayer.switchAudio(
								url[1] + '-schoolplein.mp3',
								'schoolplein',
								6
							);

						break;

						case 'speellokaal':
					
							_call_scene = 'GYMZAAL';

							/*
							Position: Set
							*/
							if(url[4] == '') {
								_coordinates_array 		= '-427|0|7';
							} else {
								_coordinates_array 		= url[4];
							}
							_coordinates_array 			= _coordinates_array.split('|');

							/*
							Set: Autoplay
							*/
							_autoplay = true;

							/*
							Side menu: toggle
							*/
							specific_digidag_sidemenu.toggleCategory('onderbouw');
							specific_digidag_sidemenu.subItemActive('speellokaal');

							/*
							Audioplayer
							*/
							specific_digidag_audioplayer.switchAudio(
								url[1] + '-speellokaal.mp3',
								'speellokaal',
								7
							);

						break;

					}

				break;

			}

			/*
			Scene: Load
			*/
			krpano.call("loadscene('scene_" + _call_scene + "',null,MERGE,BLEND(0.4)); lookat(" + _coordinates_array[0] + ',' + _coordinates_array[2] + "," + _coordinates_array[3] + ");");

			/*
			Autoplay: Set
			*/
			specific_360.setAutoplay();

			/*
			Page: Load
			*/
			switch(url[2]) {

				case 'kort-en-bondig':
					specific_digidag_menu.gotoPage('kort-en-bondig');
				break;

				case 'contact':
					specific_digidag_menu.gotoPage('contact');
				break;

				case 'ervaringen':
					specific_digidag_menu.gotoPage('ervaringen');
				break;

				case 'team':
					specific_digidag_menu.gotoPage('team');
				break;

				case 'delen':
					specific_digidag_menu.gotoPage('delen');
					addthis.init();
				break;

			}
			
			/*
			Loading: Hide
			*/
			$('.js-loading').hide();

		};

		/*
		Autoplay?
		*/
		this.setAutoplay = function() {

			if(
				typeof _autoplayTimer !== 'undefined' && 
				_autoplayTimer
			) {
				clearInterval(_autoplayTimer);
			}

			if(_autoplay == true) {

				_autoplayTimer = setTimeout(function() {
					krpano.call('set(autorotate.enabled,true)');
				},10000);

			}

		};

		/*
		Get: Info
		*/
		this.getInfo = function(_scene) {

			$.ajax({
				url: globalUrl + '/a/l/scene-info',
				method:'POST',
				data:{
					scene:_scene
				},
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				/*
				Zet in infobox
				*/
				$('.js-info-inside').html(data);

			})
			.always(function() {
			});

		};

		/*
		Coordinates
		*/
		this.trackCoordinates = function() {
					
			/**
			Clear: Timeout
			**/
			clearTimeout(timeout);
		
			/**
			Track Coordinates
			**/
			var timeout = setInterval(function() {
				
				_hlookat 		= krpano.get('view.hlookat').toString().substring(0,4);
				_vlookat 		= krpano.get('view.vlookat').toString().substring(0,4);
				
				// var _url 	= new URL(document.URL);
				// var _pano 	= _url.searchParams.get("p");
				// var _look 	= _url.searchParams.get("l");
				// _look 		= _look.replace(/|/g,',');
				
				console.log(Math.round(_hlookat) + '|0|' + Math.round(_vlookat));
				
				// window.history.pushState('obj','','./?p=' + _pano + '&l=' + Math.round(_hlookat) + '|0|' + Math.round(_vlookat));
				
			},1000);
			
			
		};
		
		/*
		Tooltip
		*/
		this.tooltip = function(i,href) {
			
			if(i==='on') {
				
				if(isTooltip === 0 && isPopupOpen === 0 && screenWidth > 600) {
					
					_get = href.split('/');
					
					/**
					Get tooltip text from localStorage (JSON)
					**/
					var storage 		= localStorage.getItem('tooltips');
					var get_tooltips 	= JSON.parse(storage);
					var tooltip 		= get_tooltips[_get[0]][_get[1]];
					
					$('.tooltip .js-tooltip').html(tooltip);
				
					/**
					Show Tooltip
					**/
					$('.tooltip').show();
					
					isTooltip = 1;
					
				}
				
				/**
				Update Tooltip on Mousemove
				**/
				var _width = $('.tooltip .js-tooltip').outerWidth();
						
				$('.tooltip').css({
				   left:  mouse_posX - ((_width/2)-5),
				   top:   mouse_posY - 100
				});
				
			} else {
				
				if(isTooltip === 1) {
				
					$('.tooltip').hide();
					isTooltip = 0;
				
				}
			}
			
		};
		
		/*
		Open: Popup / Hotspot
		*/
		this.openPopup = function(id) {
			
			/**
			Hide tooltip on open popup
			**/
			$('.tooltip').hide();
			isTooltip = 0;
			
			router.beforeRoute(globalUrl + '/' + id,1);
			popup.open(0,'popspot/' + id);
			
		};
	
		/*
		Toggle: Helpscreen
		*/
		this.toggleHelpscreen = function() {
			
			popup.open(0,'helpscreen');
			
		};
		
		/*
		Toggle: Map
		*/
		// this.toggleMap = function() {
			
		// 	_url = 'map/' + url[1];
		// 	if(urlParts[1] !== '') {
		// 		_url = _url + '/' + url[2] + '/' + urlParts[3];
		// 	}
			
		// 	popup.open(0,_url);
			
		// };
		
		/*
		Toggle: VR
		*/
		this.toggleVR = function() {
			
			/**
			Disable hover
			**/
			//$('.js-button-vr').unbind("mouseenter mouseleave");
			
			var krpano = document.getElementById('krpanoSWFObject');
		
			if(isVR === 0) {
				krpano.call("webvr.enterVR()");
				//$('.js-button').hide();
				// $('js-button-gyroscope').hide();
			} else {
				//$('.js-button').show();
				//$('js-button-gyroscope').show();
			}
			
		};
		
		/*
		Toggle: Gyroscope
		*/
		// this.toggleGyroscope = function() {
			
		// 	/**
		// 	Disable hover
		// 	**/
		// 	//$('.js-button-360').unbind("mouseenter mouseleave");
			
		// 	var krpano = document.getElementById('krpanoSWFObject');
		
		// 	if(isGyro === 0) {
		// 		krpano.set("plugin[gyro].enabled", "true");
		// 		$('.js-button-fullscreen').hide();
		// 		$('.js-button-vr').hide();
		// 		// $('.js-gyroscope-onoff').removeClass('icon-extra-off');
		// 		// $('.js-gyroscope-onoff').addClass('icon-extra-on');
		// 		isGyro = 1;
		// 	} else {
		// 		krpano.set("plugin[gyro].enabled", "false");
		// 		$('.js-button-fullscreen').show();
		// 		$('.js-button-vr').show();
		// 		// $('.js-gyroscope-onoff').removeClass('icon-extra-on');
		// 		// $('.js-gyroscope-onoff').addClass('icon-extra-off');
		// 		isGyro = 0;
		// 	}
			
		// };
		
		/*
		Toggle: Fullscreen
		*/
		this.toggleFullscreen = function() {
			
			if(isFullscreen === 1) {
				
				/*
				Switch icon
				*/
				$('.js-button-fullscreen').removeClass('active');
				
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
				
				isFullscreen = 0;
				
			} else {
				
				var element = document.documentElement;
				
				  if(element.requestFullscreen) {
					element.requestFullscreen();
				  } else if(element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				  } else if(element.webkitRequestFullscreen) {
					element.webkitRequestFullscreen();
				  } else if(element.msRequestFullscreen) {
					element.msRequestFullscreen();
				  }
				  
				  
				/*
				Switch icon
				*/
				$('.js-button-fullscreen').addClass('active');
				  
				isFullscreen = 1;
			}
			
		};
			
	
}).apply(specific_360); 